module.exports = __webpack_public_path__ + "static/media/Pushpendra Singh.946bd835.jpeg";